var _path, _path2, _path3, _path4, _use, _use2, _use3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgGg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-gg",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8112d",
    d: "M256 0h128v480H256z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8112d",
    d: "M0 176h640v128H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "gg-a",
    fill: "#f9dd16",
    d: "m110 286.7 23.3-23.4h210v-46.6h-210L110 193.3z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gg-a",
    width: 36,
    height: 24,
    transform: "rotate(90 320 240)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gg-a",
    width: 36,
    height: 24,
    transform: "rotate(-90 320 240)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gg-a",
    width: 36,
    height: 24,
    transform: "rotate(180 320 240)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGg);
export default __webpack_public_path__ + "static/media/gg.b8779f1806c259de289ac4b3919fd732.svg";
export { ForwardRef as ReactComponent };